// The only value the SPA reads from the Rails-rendered page (ADR 0007): the CSRF token, which
// every state-changing /api request sends as X-CSRF-Token.
export function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''
}
